import { ReadStore, WriteStore } from "@/types/store";
import { APIService } from "@/services/api";
import { API } from "@/lib/api";

export const StoreService = new APIService<ReadStore, WriteStore>(API.Stores);
